import { render, staticRenderFns } from "./TaskListItem.vue?vue&type=template&id=cc4889cc&scoped=true&"
import script from "./TaskListItem.vue?vue&type=script&lang=js&"
export * from "./TaskListItem.vue?vue&type=script&lang=js&"
import style0 from "./TaskListItem.vue?vue&type=style&index=0&id=cc4889cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4889cc",
  null
  
)

export default component.exports